import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

export const CustomModal = styled(Modal)`
  .modal-content {
    width: 100%;
    max-width: 400px;
  }

  .modal-header {
    margin-bottom: 18px;
  }

  .modal-title {
    font-size: 20px;
  }

  label {
    font-family: 'Fira Sans', sans-serif;
    font-size: 13px;
    margin-bottom: 4px;
  }

  input {
    height: 38px;
    padding: 0 12px;
    background: #e9ebee;
    border-radius: 5px;
    font-size: 14px;
    border: 0;
    color: #505e74;
    width: 100%;
  }
`;
